<template>
	<div class="flex items-center gap-3 rounded-md bg-grey-1 text-white text-xs h-10 px-3">

		<div v-if="!isHideBalance" class="flex items-center gap-2">
			<img v-if="currency == 'usd'" :src="require(`@/assets/logo/abx.png`)" class="h-6">

			<img v-else-if="$store.getters.paymentMethod == 'rped'" class="logo-bagi" :src="`${publicPath}assets/img/logo-bagi.png`" alt="">
			<img v-else-if="$store.getters.paymentMethod == 'gopay'" class="logo-bagi rounded" :src="`${publicPath}assets/img/logo-gopay-2.jpg`" alt="">

			<Loader v-if="this.$store.state.setBalancesApiStatus == 'loading'" class="" size_prop='2.2em'
				borderSize_prop='0.4em'>
			</Loader>

			<div v-else class="text-nowrap leading-normal">
				<div v-if="$store.getters.paymentMethod == 'gopay' && !$store.getters.isGopayLinked">
					Lakukan Order Beli
				</div>
				<div v-else>
					{{ currencySymbol }} {{ balanceShow }}
				</div>
			</div>

		</div>

		<div class="flex items-center gap-2">
			<div class="cursor-pointer" title="show/hide balance" @click="toggleBalance()">
				<IconEyeClose v-if="isHideBalance" width_prop="1rem" height_prop="1rem" />
				<IconEyeOpen v-if="!isHideBalance" width_prop="1rem" height_prop="1rem" />
			</div>

			<div class="cursor-pointer" title="refresh page" @click="refreshBalance()">
				<IconRefresh width_prop="1rem" height_prop="1rem" />
			</div>
		</div>

		<!-- <i id="eye" :class="`far fa-eye${eye_icon} mr-2\.5`" @click="toggleBalance()" title="show/hide balance"></i>
		<i :class="{ 'reload-icon': true, 'fas': true, 'fa-sync-alt': true, 'c-fa-disabled': getDepositIsCooldown }"
			@click="refreshBalance()" title="refresh page"></i> -->
	</div>
</template>

<script>
/*eslint-env jquery*/
import { Decimal } from 'decimal.js'

import LogoAbx from '@/components/svg/logo-abx.vue'
import Loader from '@/components/Loader.vue'

import IconEyeClose from '@/components/icons/IconEyeClose.vue'
import IconEyeOpen from '@/components/icons/IconEyeOpen.vue'
import IconRefresh from '@/components/icons/IconRefresh.vue'

import utils from '../utils'

export default {
	name: 'Balance',
	props: {
		hin_prop: {
			type: String,
			default: '-'
		}
	},

	components: {
		LogoAbx,
		Loader,

		IconEyeClose,
		IconEyeOpen,
		IconRefresh,
	},

	data() {
		return {
			publicPath: process.env.BASE_URL,
			colorTheme: getComputedStyle(document.documentElement).getPropertyValue('--color-theme'),
			eye_icon: '',
			eye_title: 'Hide',
			isHideBalance: false,

		}
	},

	computed: {
		hin() {
			return this.hin_prop
		},

		currency() {
			return this.$store.state.currency
		},

		streamingRateOtherCurrency() {
			return this.$store.getters['demoTopUp/getRateSgdToIdr']
		},

		balance() {
			let currency = this.currency
			if (currency == 'usd') {
				return this.$store.state.balanceUsd
			} else if (currency == 'sgd') {
				return Decimal.div(this.$store.state.balanceIdr, this.$store.getters['demoTopUp/getRateSgdToIdr'].streamBuy).toNumber()
			} else if (currency == 'myr') {
				return Decimal.div(this.$store.state.balanceIdr, this.$store.getters['demoTopUp/getRateMyrToIdr'].streamBuy).toNumber()
			} else {
				return this.$store.state.balanceIdr
			}
		},

		balanceShow() {
			return utils.currencyFormat(this.balance.toFixed(2), this.currency)
		},

		getDepositIsCooldown() {
			return this.$store.state.getDepositIsCooldown
		}
	},

	methods: {
		toggleBalance() {
			// let demo_bgc = document.getElementById("demo").style
			if (this.eye_icon == '') {
				// demo_bgc.backgroundColor = "transparent"
				this.eye_icon = '-slash'
				this.eye_title = 'Show'
				this.balance_paddingTop = 10
			} else {
				// demo_bgc.backgroundColor = "rgb(46,61,97)"
				this.eye_icon = ''
				this.eye_title = 'Hide'
				this.balance_paddingTop = 5
			}
			this.isHideBalance = (this.isHideBalance) ? false : true
		},

		refreshBalance() {
			if (!this.$store.state.getDepositIsCooldown) {
				this.$store.dispatch('setBalances')
			}
		},

		topUp() {
			if (this.$route.name === 'Top Up') {
				// same route — just scroll to top
				window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
			} else {
				this.$router.push({
					name: 'Top Up',
				})
			}
		},
	}
}
</script>

<style scoped>
.logo-bagi {
	width: 2.125em;
	height: auto;
	margin-right: 0.5rem;
	border-radius: none;
}
</style>
